<template>
  <div class="signup-comp">
    <!-- pc -->
    <div class="pc signup-container">
      <div class="flex-center" style="padding-bottom: 24px;">
        <div v-for="(item, idx) in steps" :key="'step-' + idx" class="flex-align step">
          <div class="circle" :class="{ 'circle-select': step === idx }">{{ idx + 1 }}</div>
          <div class="body2-medium" :class="{ 'main': step === idx, 'sub5': step !== idx }">{{ item }}</div>
        </div>
      </div>
      <div class="signup-wrapper">
        <div class="subtitle3 main" style="margin-bottom: 40px">회원가입</div>

        <!-- SNS 가입 -->
        <div class="body4 sub2">SNS으로 간편하게 회원가입</div>
        <sns-signin></sns-signin>

        <div class="position-relative margin-top-28">
          <div class="divider"></div>
          <div class="flex-center">
            <div class="body5 sub3 other">또는</div>
          </div>
        </div>

        <div v-for="(form, idx) in formData" :key="`form-${idx}`">
          <div class="signup-label">{{ form.label }}</div>
          <component :is="form.component_name"
                     v-bind.sync="form"
                     @etc="e => form.etc = e"
                     @onEnter="signup"
                     class="margin-top-8" :key="`form-${idx}`"></component>
          <div v-if="form.label === '추천인코드'" class="flex-align margin-top-8" style="gap: 4px;">
            <div class="body6-medium tag">이벤트</div>
            <div class="sub3 body5">추천인 코드를 입력하면 50,000원 쿠폰을 드려요.</div>
          </div>
        </div>
        <div style="padding-top:20px">
          <div v-for="(form, idx) in checkFormData" :key="`form-${idx}`">
            <component :is="form.component_name"
                       v-bind.sync="form"
                       class="margin-top-8" :key="`form-${idx}`"></component>
          </div>
        </div>
        <button class="button is-primary body2-medium" style="width:100%;margin-top:40px" @click="signup">다음</button>
        <!--<div class="margin-top-20">
          <span class="sub">이미 회원이신가요?</span>
          <span class="primary margin-left-8 unselect" @click="routerPush('signin')">로그인</span>
        </div>-->
      </div>
    </div>

    <!-- mobile -->
    <div class="mobile signup-container">
      <div class="flex-center" style="padding-bottom: 24px;">
        <div v-for="(item, idx) in steps" :key="'step-' + idx" class="flex-align step">
          <div class="circle" :class="{ 'circle-select': step === idx }">{{ idx + 1 }}</div>
          <div class="body2-medium" :class="{ 'main': step === idx, 'sub5': step !== idx }">{{ item }}</div>
        </div>
      </div>
      <div class="signup-wrapper">
        <div class="h7 main" style="margin-bottom: 20px">회원가입</div>

        <!-- SNS 가입 -->
        <!-- <div class="body4 sub2">SNS으로 간편하게 회원가입</div>
        <sns-signin></sns-signin>

        <div class="position-relative margin-top-28">
          <div class="divider"></div>
          <div class="flex-center">
            <div class="body5 sub3 other">또는</div>
          </div>
        </div> -->

        <div v-for="(form, idx) in formData" :key="`form-${idx}`">
          <div class="signup-label">{{ form.label }}</div>
          <component :is="form.component_name"
                     v-bind.sync="form"
                     @onEnter="signup"
                     @etc="e => form.etc = e"
                     class="margin-top-8" :key="`form-${idx}`"></component>
          <div v-if="form.label === '추천인코드'" class="flex-align margin-top-8" style="gap: 4px;">
            <div class="body6-medium tag">이벤트</div>
            <div class="sub3 body6">추천인 코드를 입력하면 50,000원 쿠폰을 드려요.</div>
          </div>
        </div>
        <div style="padding-top:20px">
          <div v-for="(form, idx) in checkFormData" :key="`form-${idx}`">
            <component :is="form.component_name"
                       v-bind.sync="form"
                       class="margin-top-8" :key="`form-${idx}`"></component>
          </div>
        </div>
        <button class="button is-primary body2-medium" style="height:48px;width:100%;margin-top:40px" @click="signup">다음</button>
      </div>
    </div>
  </div>
</template>

<script>
  import FormMixin from "../../../mixins/FormMixin";
  import LpText from "../../component/LpText";
  import LpCheckBoxArray from "../../component/LpCheckBoxArray";
  import SnsSignin from "../../component/SnsSignin";
  import LpDropDown from "../../LpDropDown.vue";
  
  export default {
    name: "SignupComp",
    components: {SnsSignin, LpCheckBoxArray, LpText, LpDropDown},
    mixins: [
      FormMixin
    ],
    created() {
      if(this.$store.getters.recmCode!=='') {
        let recm = this.formData.find(i => i.field === 'recommender');
        recm.value = this.$store.getters.recmCode;
      }
    },
    data() {
      return {
        step: 0,
        steps: ['정보입력','가입인증','가입완료'],
        formData: [
          {
            label: '이름',
            placeholder: '이름을 입력해주세요.',
            maxLength: 20,
            field: 'name',
            type: 'text',
            value: '',
            component_name: 'lp-text',
            errorMsg: '',
            validate: {
              num: true,
              alpha_g: true,
              alpha_s: true,
              special: true,
              max_length: 20,
              min_length: 1,
              valid_required: true,
              required: true
            }
          },
          {
            label: '이메일',
            placeholder: 'example@gmail.com',
            maxLength: 100,
            field: 'username',
            type: 'email',
            value: '',
            component_name: 'lp-text',
            errorMsg: '',
            validate: {
              valid_required: true,
              required: true
            }
          },
          {
            label: '연락처',
            placeholder: '',
            maxLength: 30,
            field: 'phone',
            type: 'phone',
            value: '',
            component_name: 'lp-text',
            errorMsg: '',
            validate: {
              valid_required: true,
              required: true
            }
          },
          {
            label: '비밀번호',
            placeholder: '',
            maxLength: 30,
            field: 'password',
            type: 'password',
            value: '',
            component_name: 'lp-text',
            errorMsg: '',
            validate: {
              valid_required: true,
              required: true
            }
          },
          {
            label: '비밀번호 확인',
            placeholder: '',
            maxLength: 30,
            field: 'password_re',
            type: 'password',
            value: '',
            component_name: 'lp-text',
            errorMsg: '',
            validate: {
              valid_required: true,
              required: true
            }
          },
          {
            label: '추천인코드',
            placeholder: '추천인코드를 입력해주세요',
            maxLength: 20,
            field: 'recommender',
            type: 'text',
            value: '',
            component_name: 'lp-text',
            errorMsg: '',
            validate: {
              num: true,
              alpha_g: true,
              alpha_s: true,
              special: true,
              max_length: 10,
              min_length: 1,
              valid_required: false,
              required: false
            }
          },
          {
          label: '가입경로',
          placeholder: '플랫폼파이를 어떻게 찾으셨나요?',
          maxLength: 30,
          field: 'funnel',
          type: 'dropdown',
          value: '',
          etc: '',
          component_name: 'lp-drop-down',
          errorMsg: '',
          options: [
            { value: 1, label: '뉴스, 기사' },
            { value: 2, label: '커뮤니티' },
            { value: 3, label: '인스타그램' },
            { value: 4, label: '페이스북' },
            { value: 5, label: '네이버 블로그' },
            { value: 6, label: '검색' },
            { value: 7, label: '친구 추천' },
            { value: 8, label: '타 사이트 하단 powered by 정보 확인' },
            { value: 9, label: '기타' },
          ],
          validate: {
            num: true,
            alpha_g: true,
            alpha_s: true,
            special: true,
            max_length: 30,
            min_length: 1,
            valid_required: true,
            required: true
          }
        },
        ],
        checkFormData: [
          {
            field: 'term',
            type: 'check',
            value: false,
            component_name: 'lp-check-box-array',
            errorMsg: '',
            validate: {
              valid_required: true
            },
            items: [
              {
                label: '이용약관 동의',
                labelStyle: {
                  fontSize: '15px',
                  color: '#333333'
                }
              },
              {
                label: '약관보기', link: '/term',
                labelStyle: {
                  color: '#828282',
                  fontSize: '15px',
                  textDecoration: 'underline',
                  marginLeft: '8px'
                }
              }
            ]
          },
          {
            field: 'limit',
            type: 'check',
            value: false,
            component_name: 'lp-check-box-array',
            errorMsg: '',
            validate: {
              valid_required: true
            },
            items: [
              {
                label: '개인정보 취급방침 동의',
                labelStyle: {
                  fontSize: '15px',
                  color: '#333333'
                }
              },
              {
                label: '약관보기', link: '/privacy',
                labelStyle: {
                  color: '#828282',
                  fontSize: '15px',
                  textDecoration: 'underline',
                  marginLeft: '8px'
                }
              }
            ]
          }
        ]
      }
    },
    methods: {
      signup() {
        if(!this.checkFormData[0].value) {
          this.toast('이용약관에 동의해주세요');
          return;
        } else if(!this.checkFormData[1].value) {
          this.toast('개인정보 취급방침에 동의해주세요');
          return;
        }
        let result = this.getParamData(this.formData);
        if(result.params.password !== result.params.password_re) {
          this.toast('비밀번호와 확인 값이 일치하지 않습니다.');
          return;
        }

        if(result.enable) {
          result.params.channel = '플랫폼파이';
          this.$axios.post('auth/user/signup', result.params).then(res => {
            if (res.status === 200) {
              this.setGa('가입 1단계 완료', '응답', '가입 1단계 완료');
              this.$router.push(`signemail?email=${result.params.username}`);
              this.$store.commit('recmCode', '')
            }
          }).catch(error => {
            if (error.response) {
              let res = error.response;
              this.toast(res.data.message);
            }
          })
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
  @import '~assets/css/lp_main'
  .signup-container
    text-align center

  .signup-wrapper
    border 1px solid $gray2
    border-radius 12px
    background-color white
    padding 40px
  .signup-label
    text-align left
    margin-top 16px
    color $sub3
    font-size 15px

  .circle
    width 24px
    height 24px
    border-radius 100%
    line-height 24px
    text-align center
    background-color $sub5
    color white
    margin-right 4px

  .circle-select
    background-color $main

  .step
    margin-left 45px
  .step:first-child
    margin-left 0

  .divider
    position absolute
    width 100%
    height 1px
    background-color $gray1
    top 8px
  .other
    z-index 1
    background-color white
    padding 0 20px

  @media (min-width:1025px)
    .signup-container
      margin-top 80px
      width 448px

  @media (max-width:1024px)
    .signup-comp
      width 100%
      padding 40px 16px
    .signup-container
      width 100%

    .signup-wrapper
      padding 32px 20px
    .signup-label
      font-size 14px
    .step
      margin-left 0
      width 33.33333%
      justify-content center

  .tag
    width 42px
    height 20px
    padding 1px 4px
    border-radius 2px
    color $subcolor2
    background-color $subcolor50
  
</style>
